import { CompanyStatusEnum } from '../../../types/schema';

export function isCompanyActive(status?: CompanyStatusEnum): boolean {
  return Boolean(status && status === CompanyStatusEnum.Active);
}
